module.exports = __webpack_public_path__ + "img/wibot-animated.55c2d681.png";